// 全局数据
var globalData = {
  // 关闭当前pooover卡片的方法
  closeCurPopover: function closeCurPopover() {},
  // 未登录发起请求是否要跳转至登录页面
  unLoginRedirect: false
};

export { globalData };
